<template>
  <main>
    <marketing-sms-list />
  </main>
</template>

<script>
import MarketingSmsList from "@components/modules/marketing/sms/list/MarketingSmsList";

export default {
  components: {
    MarketingSmsList,
  },

  data() {
    return {};
  },

  beforeCreate() {},

  computed: {},

  mixins: [],
};
</script>

<style lang="scss" scoped>
</style>
